import xieyi from '@/components/xieyi'
import AutoForm from '@/components/AutoForm'
import QRCode from "qrcode";
export default {
  components: {
    xieyi, AutoForm
  },
  props: {},
  data() {
    // 再次输入密码验证
    let validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.form.Password) {
        callback(new Error('两次输入的密码不一致!'));
      } else {
        callback();
      }
    };
    // 证件号码格式验证
    let validateConfirmIdCard = (rule, value, callback) => {
      switch (this.form.ContractsCardType) {
        case 0: //
          validateIdCard(rule, value, callback);
          break;
        case 1:
          validatePassport(rule, value, callback);
          break;
        case 2:
          validateMilitaryCard(rule, value, callback);
          break;
        case 9:
          validateHMPassCard(rule, value, callback);
          break;
      }
    };
    // 短信验证码
    let VcodeRegex = (rule, value, callback) => {
      if (value != '123456') {
        callback(new Error('验证码不正确'));
      } else {
        callback();
      }
    }

    let validateCutomname = (rule, value, callback) => {
      var self = this;
      self.$http.post(self.url.vUserName, {
        Data: self.form.Name
      }).then(result => {
        if (!result) {
          callback(new Error('用户名称已存在，换一个吧~'));
        } else {
          callback();
        }
      }, () => {

      });
    }

    return {
      xieyiVisible: false,
      url: {
        save: SZH.assets.api + '/Login/Login',
        LoginForPhone: SZH.assets.api + '/Login/LoginForPhone',
        GetClientsUserJson: SZH.assets.api + '/ClientsData/GetClientsUserJson',
        Join: SZH.assets.api + '/Notice/Join',
        RefrenshScanCode: SZH.assets.api + '/Notice/RefrenshScanCode',
        ScanLogin: SZH.assets.api + '/Login/ScanLogin',
      },
      captchaUrl: SZH.assets.api + '/Login/GetAuthCode2',
      SendVerifyCodeForLogin: SZH.assets.api + '/Login/SendVerifyCodeForLogin',

      captchaUrlTails: 'feelingscoder',
      checked: true,
      form: {
        UserName: '', // 登录账号
        Password: '', // 登录密码
        Captcha: '', // 验证码 2021/11/8
        LoginTerminal: 0, // 验证码 2021/11/8
      },
      rules: {

        Captcha: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
          }
        ],
        UserName: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur'
          },
          {
            min: 6,
            max: 25,
            message: '登录账号长度应在 6 到 25 个字符之间',
            trigger: 'blur'
          },
          {
            validator: validateUsername,
            trigger: 'blur'
          }
        ],
        Password: [
          {
            required: true,
            message: '请输入登录密码',
            trigger: 'blur'
          },
          {
            validator: validatePassword,
            trigger: 'blur'
          }
        ],
        RePassword: [
          {
            required: true,
            message: '请再次输入密码',
            trigger: 'blur'
          },
          {
            validator: validateConfirmPassword,
            trigger: 'blur'
          }
        ],
        PhoneNumber: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          {
            validator: validatePhone,
            trigger: 'blur'
          }
        ],
        Vcode: [
          {
            required: true,
            message: '请输入短信验证码',
            trigger: 'blur'
          },
          {
            min: 6,
            max: 6,
            message: '短信验证码长度应为6个字符',
            trigger: 'blur'
          }
        ],

      },
      checkbox: true,
      loading: null,
      fullscreenLoading: false,
      userOrPhone:'username',
      formPhone:{
        Captcha:'',
        VCode:'',
        Phone:''
      },
      btnName:'获取验证码',
      setintIndex:null,
      sendVCodeTime:59,
      userInfo:{
        UserId:'',
        UserCode:'',
        UserName:''
      },
      uuid:'',
      ClientId:'',
      QRCodeMsg:'',
      proxy:{}
    }
  },
  methods: {
    getCode(){
      let self = this;
      if(!self.formPhone.Phone){
        self.$message.error('请输入手机号！');
        return
      }
      if(!self.formPhone.Captcha){
        self.$message.error('请输入图片验证码！');
        return
      }
      //如果存在定时器不再调用接口
      if(self.setintIndex){
        return
      }
      //TODO
      self.sendVerifyCodeForRegisterFun();
      //调用接口成功调用下面的方法

    },
    sendVerifyCodeForRegisterFun(){
      let self = this;
      self.fullscreenLoading = true;
      self.$http.post(self.SendVerifyCodeForLogin, {
        Phone:self.formPhone.Phone,
        Captcha:self.formPhone.Captcha
      }).then(result => {
        if (result.state == true) {
          self.$message.success('短信发送成功!');
          self.getReturnTime();
        } else {
          self.$message.error(result.message);
        }
        self.fullscreenLoading = false;
      }, () => {
        // 请求失败
        self.fullscreenLoading = false;
        self.$message.error('获取失败，请检查您的网络是否可用。');
      });
    },
    getReturnTime(){
      this.btnName = '倒计时:'+this.sendVCodeTime+'s';
      this.setintIndex = setInterval(()=>{
        --this.sendVCodeTime;
        this.btnName = '倒计时:'+this.sendVCodeTime+'s';
        if(this.sendVCodeTime == 0){
          clearInterval(this.setintIndex);
          this.btnName = '获取验证码';
          this.sendVCodeTime = 59;
        }
      },1000)
    },
    handleClick(){

    },
    turnTo(url) {
      this.$router.push({
        path: url
      })
    },
    toRegesit() {
      this.$router.push({
        path: '/RegisterTH'
      })
    },
    toLogin() {
      var self = this;
      if (!self.checkbox) {
        self.$message.error('请阅读并同意《服务协议》后再进行后续操作！');
      } else {
        if(self.form.UserName == ''){
          self.$message.error("请输入用户名");
          return
        }
        if(self.form.Password == ''){
          self.$message.error("请输入密码");
          return
        }
        if(self.form.Captcha == ''){
          self.$message.error("请输入验证码");
          return
        }
        self.fullscreenLoading = true;
        self.form.Password = hex_md5(self.form.Password);
        self.$http.post(self.url.save, self.form)
          .then(result => {
            if (result.state == true) { // 注册成功
              // self.$message.success('登录成功!');
              self.$message({
                message: "登录成功!",
                type: "success",
                duration: 1000,
              });
              localStorage.setItem('ms_isLogin', true);
              localStorage.setItem('ms_username', self.form.UserName);
              self.$router.push({
                path: '/'
              });
              // self.connectServer()
            } else {
              self.$message.error(result.message);
              self.form.Password = ''
              self.refreshCaptcha()

            }
            self.fullscreenLoading = false;
          }, () => {
            // 请求失败
            self.$message.error('登录失败，请检查您的网络是否可用。');
            self.fullscreenLoading = false;
          });
      }
    },
    refreshCaptcha() {
      let self = this;
      self.captchaUrlTails = Math.random();
      // this.form.password = '';
      self.form.Captcha = '';
    },
    refreshCaptchaP() {
      let self = this;
      self.captchaUrlTails = Math.random();
      // this.form.password = '';
      self.formPhone.Captcha = '';
    },
    toLoginPhone(){
      var self = this;
      if (!self.checkbox) {
        self.$message.error('请阅读并同意《服务协议》后再进行后续操作！');
      } else {
        if(!self.formPhone.Phone){
          self.$message.error('请输入手机号！');
          return
        }
        if(!self.formPhone.Captcha){
          self.$message.error('请输入图片验证码！');
          return
        }
        if(!self.formPhone.VCode){
          self.$message.error('请输入短信验证码！');
          return
        }
        self.fullscreenLoading = true;
        self.$http.post(self.url.LoginForPhone, self.formPhone)
          .then(result => {
            if (result.state == true) { // 注册成功
              self.$message.success('登录成功!');
              localStorage.setItem('ms_isLogin', true);
              localStorage.setItem('ms_username', result.data);
              self.$router.push({
                path: '/'
              });
            } else {
              self.$message.error(result.message);
            }
            self.fullscreenLoading = false;
          }, () => {
            // 请求失败
            self.$message.error('登录失败，请检查您的网络是否可用。');
            self.fullscreenLoading = false;
          });
      }
    },
    S4() {
      return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
    },
    guid() {
      return (this.S4()+this.S4()+"-"+this.S4()+"-"+this.S4()+"-"+this.S4()+"-"+this.S4()+this.S4()+this.S4());
    },
    getQRCode() {
      let opts = {
        errorCorrectionLevel: "H",//容错级别
        type: "image/png",//生成的二维码类型
        quality: 0.3,//二维码质量
        margin: 15,//二维码留白边距
        width: 300,//宽
        height:300,//高
        text: this.uuid,//二维码内容
        color: {
          dark: "#333333",//前景色
          light: "#fff"//背景色
        }
      };
      this.QRCodeMsg = this.uuid; //生成的二维码为URL地址js
      let msg = document.getElementById("QRCode_header");
      // 将获取到的数据（val）画到msg（canvas）上
      QRCode.toCanvas(msg, this.QRCodeMsg, opts,  (error)=> {
        console.log(this.QRCodeMsg)
      });
    },
    refreshCode(){
      let self = this;
      self.uuid = self.guid();
      self.$http.post(self.url.RefrenshScanCode, {
        ScanKey:self.uuid,
        ClientId:self.ClientId
      }).then(result => {
        if (result.state == true) {
          self.getQRCode();
        } else {
          self.$message.error(result.message);
        }
      }, () => {
        // 请求失败
        self.$message.error('获取失败，请检查您的网络是否可用。');
      });

    },
    connectServer() {
      var $this = this;
      var conn = $.hubConnection(SZH.assets.ws, {qs:`scanKey=${this.uuid}`});

      console.log(conn.id);
      $this.proxy = conn.createHubProxy("NoticeHub");
      $this.toLoginByEwm();
      conn.start().done((connection) => {
        // $this.sendMsg();
        $this.ClientId = connection.id;
      }).fail((data) => {
      });
    },
    sendMsg() {
      var $this = this;
        $this.proxy.invoke("RefrenshScanCode", {ScanKey:this.uuid,ClientId:this.ClientId}).done((msg) => {
      });
    },
    toLoginByEwm() {
      var $this = this;
      $this.proxy.on("ScanLogin", (data) => {
        console.log(data)
        let scanObj = data;
        if(scanObj && scanObj.ScanKey == $this.uuid){
          $this.toScanLogin(scanObj);
        }else{
          $this.message.error('二维码失效，请刷新重试')
        }
      });

    },
    toScanLogin(obj){
      let self = this;
      self.fullscreenLoading = true;
      self.$http.post(self.url.ScanLogin, {
        ScanKey:obj.ScanKey,
        UserName:obj.UserCode
      })
        .then(result => {
          if (result.state == true) { // 注册成功
            self.$message({
              message: "登录成功!",
              type: "success",
              duration: 1000,
            });
            localStorage.setItem('ms_isLogin', true);
            localStorage.setItem('ms_username', obj.UserCode);
            self.$router.push({
              path: '/'
            });
            // self.connectServer()
          } else {
            self.$message.error(result.message);
          }
          self.fullscreenLoading = false;
        }, () => {
          // 请求失败
          self.$message.error('登录失败，请检查您的网络是否可用。');
          self.fullscreenLoading = false;
        });
    },
  },
  computed: {
    captchaFullUrl() {
      let self = this;
      return self.captchaUrl + "?tails=" + self.captchaUrlTails;
    }
  },
  created() {

  },
  mounted() {
    this.uuid = this.guid();
    this.refreshCaptcha();
    this.getQRCode();
    this.connectServer();
  },
  watch: {}
}



// WEBPACK FOOTER //
// ./src/views/LoginTH/LoginTH.js